import HeaderSection from "@/components/Header/HeaderSection.vue";
import BolideAssistant from "@/components/BolideAssistant/BolideAssistant.vue";
import SettingsUserManagementTab from "@/components/SettingsUserManagementTab/SettingsUserManagementTab.vue";
import PortfolioSidebar from "@/components/PortfolioSidebar/PortfolioSidebar.vue";
import PropertySidebar from "@/components/PropertySidebar/PropertySidebar.vue";
import sidebar_page_context from "@/components/sidebar_page_context";
import { get_user_profile, fetch_and_store_user_profile } from "@/router";

export default {
    name: "UserManagementView",

    // Sidebars read the collapsed state from here (they used to look for it on $root, where it never existed)
    provide() {
        return ({
            is_sidebar_collapsed: () => this.sidebar_collapsed
        });
    },

    mixins: [sidebar_page_context],

    components: {
        HeaderSection,
        BolideAssistant,
        SettingsUserManagementTab,
        PortfolioSidebar,
        PropertySidebar
    },

    data() {
        return ({
            show_assistant: false,
            is_mobile: window.innerWidth < 768,
            mobile_sidebar_open: false,
            sidebar_collapsed: true,
            user_profile: null,
            breadcrumb: [
                { id: "home", title: "Dashboard" },
                { id: "user_management", title: "User Management" }
            ]
        });
    },

    async mounted() {
        window.addEventListener("resize", this.handle_resize);
        this.user_profile = get_user_profile() || await fetch_and_store_user_profile();
    },

    beforeUnmount() {
        window.removeEventListener("resize", this.handle_resize);
    },

    methods: {
        handle_resize() {
            this.is_mobile = window.innerWidth < 768;
            if (!this.is_mobile) this.mobile_sidebar_open = false;
        },

        handleBreadcrumbClick(id) {
            if (id === "home") {
                this.$router.push("/home");
            }
        },

        toggle_mobile_sidebar() {
            this.mobile_sidebar_open = !this.mobile_sidebar_open;
        }
    }
};
